import * as React from 'react';
import Select from 'react-select';
import {useForm, useFieldArray} from "react-hook-form";
import {useEffect, useState} from "react";
import {ProposalPermissions, ProposalReviewPermissions, Review, ReviewStatus, Staff} from "./types.ts";
import axios from 'axios';
import QuestionIcon from "../Components/QuestionIcon.tsx";
import {STATUS_STYLES} from "../Components/BaseConstants.ts";

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.maxRedirects = 0;


interface PropTypes {
    disabled: boolean,
    proposalReviews: Review[],
    reviewers: Staff[],
    statusList: ReviewStatus[],
    permissions: ProposalPermissions,
    multiDiscipline: boolean
}

export function ProposalReviews({
                                    disabled,
                                    proposalReviews,
                                    reviewers,
                                    statusList,
                                    permissions,
                                    multiDiscipline
                                }: PropTypes) {
    const reviewersLookup = Object.fromEntries(reviewers.map((staff) => [staff.pkStaffid, staff]));


    const proposalReviewsWithPerms: (Review & {
        permissions?: ProposalReviewPermissions,
        entityId?: number
    })[] = proposalReviews.map((r, i) => ({
        ...r,
        entityId: r.id,
        permissions: disabled ? {} : permissions['proposal_review'][i]
    }))

    // const anObject = Object.fromEntries(proposalReviewsWithPerms.map((r) => [r.id, {...r}]))


    // const aReviewInTheListHasStatusAcceptedChanged = proposalReviews.some(review => review.reviewStatus === 'Accepted, Changed');

    const [success, setSuccess] = useState(false);


    const {reset, control, register, formState: {isDirty}} = useForm({
        defaultValues: {
            proposalReviews: proposalReviewsWithPerms,
        },
        mode: 'onChange',
    });
    const {append, remove, fields} = useFieldArray({
        control,
        name: 'proposalReviews',
    });

    useEffect(() => {
        //@ts-expect-error Function defined as html include
        if (isDirty) handleChangeEvent();
    }, [isDirty])

    useEffect(() => {
        // return;
        if (success) {
            console.log('reset without dirty values');
            reset({proposalReviews: proposalReviewsWithPerms}, {
                keepDirtyValues: false
            });
        } else {
            console.log('reset with dirty values');
            reset({proposalReviews: proposalReviewsWithPerms}, {
                keepDirtyValues: true
            });
        }
        return () => {
            setSuccess(false);
        }

    }, [proposalReviews]);

    const proposalReviewsCallNames = fields.map(v => v?.reviewer?.stfCallname);


    const reviewStatusStyles = STATUS_STYLES;

    return (
        <>
            <div className="proposalReview mb-4">
                {/*<form onSubmit={handleSubmit(onSubmit)}>*/}
                <div className={'d-flex align-items-center'}>
                    <h3 className="flex-fill mb-1">Proposal Review</h3>
                    {/*{!disabled &&*/}
                    {/*    <div>*/}
                    {/*        <input type='submit' className={'button btn'} disabled={loading}*/}
                    {/*               value='Save Review Requests'/>*/}
                    {/*    </div>*/}
                    {/*}*/}
                </div>

                {multiDiscipline && !disabled &&
                    <div className='bg-warning-subtle mb-2 p-2'>
                        Please ensure Reviews cover necessary
                        disciplines for this Proposal
                    </div>
                }

                {/*{aReviewInTheListHasStatusAcceptedChanged && !disabled &&*/}
                {/*    <div className='text-body-secondary mb-2'>*/}
                {/*        <small>*/}
                {/*            Review(s) that were previously Accepted are no longer valid due to a change in the Proposal. These reviews can either be made Not Required, or resent*/}
                {/*            so that the Reviewer can reaccept. There needs to be at least one accepted review for the Proposal to go through for Approval.*/}
                {/*        </small>*/}
                {/*    </div>*/}
                {/*}*/}

                <table className="styled">
                    <tbody>
                    {fields.map((item, index) =>
                        (
                            <tr key={item.id} className={item.reviewStatus === 'Accepted, Changed' ? "bg-warning" : ''}>
                                <td>
                                    {/*{item.new && (*/}
                                    <input name={`proposalReviews[${index}][id]`} type='hidden'
                                           value={item?.entityId}/>
                                    <input name={`proposalReviews[${index}][reviewer]`} type='hidden'
                                           value={item?.reviewer.pkStaffid}/>
                                    {/*)}*/}
                                    <div className='reviewWrapNoWrap d-flex justify-content-between column-gap-3'>
                                        <span
                                            className='text-nowrap'>{item?.reviewer?.stfFirstname} {item?.reviewer?.stfLastname}</span>
                                        {item?.permissions === undefined || item?.permissions?.['proposal_review_required.edit'] ? (
                                            <div className="form-check form-switch" style={{minHeight: 0}}>
                                                <input
                                                    //@ts-expect-error React hook form bracket syntax
                                                    id={`${index}required`} {...register(`proposalReviews[${index}][required]`)}
                                                    className="form-check-input"
                                                    type="checkbox" role="switch"/>

                                                <label className="form-check-label"
                                                       htmlFor={`${index}required`}>Required</label>

                                            </div>
                                        ) : <span
                                            className='text-body-secondary text-nowrap'>{item?.reviewStatus != 'Accepted' && (item?.required ? 'Required' : 'Not Required')}</span>
                                        }
                                    </div>

                                    <div className='text-nowrap'>
                                        {item?.permissions?.['proposal_review_status.edit'] ? (
                                            <>
                                                {
                                                    item.reviewStatus === 'Accepted, Changed' ?
                                                        <>
                                                            <small>Re-review required due to proposal changes</small>
                                                            <input
                                                                //@ts-expect-error React hook form bracket syntax
                                                                type='hidden' {...register(`proposalReviews[${index}][reviewStatus]`)}
                                                                value='Accepted, Changed'/>
                                                        </> : ''
                                                }
                                                <div className={'d-flex'}>
                                                    {
                                                        statusList.filter((v) => v != 'Accepted, Changed').map((v, i) => (
                                                            <>
                                                            <input
                                                                        //@ts-expect-error React hook form bracket syntax
                                                                        {...register(`proposalReviews[${index}][reviewStatus]`)}
                                                                        disabled={disabled}
                                                                        type="radio"
                                                                        value={v}
                                                                        id={`req${index}_${i}`}
                                                                        className="btn-check"/>
                                                                    <label
                                                                        className={`btn btn-outline-${reviewStatusStyles[v]}`}
                                                                        htmlFor={`req${index}_${i}`}
                                                                        style={{
                                                                            lineHeight: `${v == 'Accepted' ? '2.2' : '1.2'}`,
                                                                            width: '4rem',
                                                                            whiteSpace: 'pre-wrap',
                                                                            fontSize: '0.7rem',
                                                                            padding: 0,
                                                                            flexGrow: 1
                                                                        }}>
                                                                        {v}
                                                                    </label>
                                                                </>
                                                            )
                                                        )
                                                    }
                                                </div>
                                            </>

                                        ) : (item?.permissions === undefined ? (
                                                    <>
                                                        <input
                                                            //@ts-expect-error React hook form bracket syntax
                                                            type='hidden' {...register(`proposalReviews[${index}][reviewStatus]`)} />
                                                        Unsaved Review Request
                                                    </>
                                                ) :
                                                <div
                                                    title={item.reviewStatus === 'Accepted, Changed' && 'This Review was previously accepted but is no longer valid due to a change in the Proposal. The Review can either be made Not Required, or resent so that the Reviewer can reaccept. There needs to be at least one accepted review for the Proposal to go through for Approval.'}
                                                    style={{cursor: item.reviewStatus === 'Accepted, Changed' ? 'pointer' : 'auto'}}
                                                >
                                                    {item?.reviewStatus}
                                                    {item.reviewStatus === 'Accepted, Changed' &&
                                                        <QuestionIcon />
                                                    }
                                                </div>
                                        )
                                        }
                                    </div>
                                </td>
                                <td className={item?.notes ? 'w-100' : 'w-100'}>
                                    {item?.permissions === undefined || item?.permissions?.['proposal_review_notes.edit'] ? (
                                        //@ts-expect-error React hook form bracket syntax
                                        <textarea {...register(`proposalReviews[${index}][notes]`)}
                                                  placeholder="Notes" style={{height: '100%'}}
                                                  className="form-control"></textarea>
                                    ) : !!item?.notes && <textarea readOnly={true} className='bg-transparent border'
                                                                   style={{
                                                                       outline: 'none',
                                                                       cursor: 'pointer',
                                                                       overflow: 'hidden',
                                                                       marginBottom: '-0.5em'
                                                                   }} value={item.notes}></textarea>}
                                </td>
                                <td className="p-0">
                                    <div className='d-flex'>
                                        {item?.permissions === undefined || item?.permissions['proposal_review.delete'] ? (
                                            <a style={{backgroundColor: '#dfdfdf'}}
                                               onClick={() => {
                                                   remove(index)
                                                   try {
                                                   } catch (e) {
                                                   }
                                               }}
                                               className='js-delete_collection_entry'>x
                                            </a>
                                        ) : ''}
                                        {item?.permissions?.['proposal_review.resend'] ? (
                                            <div className="form-check form-switch d-flex flex-column p-0 pt-1"
                                                 style={{minHeight: 0}}>
                                                <input
                                                    //@ts-expect-error React hook form bracket syntax
                                                    id={`${index}resend`} {...register(`proposalReviews[${index}][toResendEmail]`)}
                                                    className="form-check-input m-0"
                                                    type="checkbox" role="switch"/>

                                                <label className="form-check-label"
                                                       htmlFor={`${index}resend`}>Resend Request</label>

                                            </div>
                                        ) : ''}
                                    </div>
                                </td>
                            </tr>
                        )
                    )
                    }
                    </tbody>
                </table>
                {/*</form>*/
                }

                <Select
                    isDisabled={disabled}
                    key={JSON.stringify(proposalReviewsCallNames)}
                    options={reviewers.filter(staff => !proposalReviewsCallNames.includes(staff.stfCallname)).map(v => ({
                        label: v.stfFirstname + ' ' + v.stfLastname,
                        value: v.pkStaffid
                    }))}
                    placeholder={'Request Review From...'}
                    onChange={(e) => append({
                        reviewer: reviewersLookup[e.value],
                        notes: '',
                        reviewStatus: statusList[0],
                        required: false
                    })}
                />
            </div>
        </>
    )

}
